import { CallBackProps, Step } from "react-joyride";

import create from "zustand";
import useHttpClient from "../hooks/useHttpClient";
import Tooltip, { TutorialContextType } from "./Tooltip";
import { useBerichtsheft } from "./BerichtsheftContext";
const firstYearTabQuerySelector = "a.year-tab:nth-of-type(1)";
const firstMonthAccordionQuerySelector = ".month-accordion:nth-of-type(1)";
const firstMonthCheckboxQuerySelector = "input.month-checkbox:nth-of-type(1)";
const firstReportPaperQuerySelector = ".report-paper";
const firstReportCheckboxQuerySelector = "input.report-checkbox:nth-of-type(1)";
const firstEntryRichTextEditorCell = ".entry-rich-text-editor-cell";
export const firstReportEntryAreaQuerySelector = ".report-entry-area";
const sideBarButtonQuerySelector = ".drawer";
const sideBarOverlayQuerySelector = ".drawer-overlay";
const folderSelectQuerySelector = ".folder-select";
const entryListQuerySelector = ".entry-list";
const entrySearchQuerySelector = ".entry-search";
const createEntryButtonQuerySelector = ".create-entry-button";
const multiSelectButtonQuerySelector = ".multi-select-button";
const entryAccordionQuerySelector = ".entry-accordion";
const entryAccordionCheckboxQuerySelector =
  "input.entry-checkbox:nth-of-type(1)";
const entryAccordionCompleteEntryButtonQuerySelector =
  ".entry-accordion .complete-entry-button";
const entryAccordionDeleteEntryButtonQuerySelector =
  ".entry-accordion .delete-entry-button";
const entryAccordionReportSectionSelectQuerySelector =
  ".entry-accordion .report-section-select";
const entryAccordionRichTextEditorQuerySelector =
  ".entry-accordion .rich-text-editor-container";
const entryAccordionEntryNameQuerySelector =
  ".entry-accordion input[name='name']";
const entryAccordionDurationInputQuerySelector =
  ".entry-accordion input[name='maxHours']";
const openMenuButtonQuerySelector = ".open-menu-button";
const downloadEntriesButtonQuerySelector = ".download-entries-button";
const randomizeEntriesButtonQuerySelector = ".randomize-entries-button";
const calendarEntriesButtonQuerySelector = ".import-ical-entries-button";
const exportReportsButtonQuerySelector = ".export-reports-button";
const startTutorialButtonQuerySelector = ".start-tutorial-button";

function openFirstReportAccordion() {
  const reportCheckbox = document.querySelector<HTMLInputElement>(
    firstReportCheckboxQuerySelector
  );
  if (reportCheckbox !== null && reportCheckbox.checked == false) {
    reportCheckbox.click();
  }
}

function elementExists(selector: string) {
  const element = document.querySelector(selector);
  return element !== null && element !== undefined;
}

function firstMonthAccordionCheckboxExists() {
  return elementExists(firstMonthCheckboxQuerySelector);
}
function reportSectionSelectExists() {
  return elementExists(entryAccordionReportSectionSelectQuerySelector);
}

function durationInputExists() {
  return elementExists(entryAccordionDurationInputQuerySelector);
}

function openFirstMonthAccordion() {
  const monthEl = document.querySelector<HTMLInputElement>(
    firstMonthCheckboxQuerySelector
  );
  if (monthEl !== null && monthEl.checked == false) {
    monthEl.click();
  }
}
function openFirstEntryAccordion() {
  const entryAccordion = document.querySelector<HTMLInputElement>(
    entryAccordionCheckboxQuerySelector
  );
  if (entryAccordion !== null && entryAccordion.checked == false) {
    entryAccordion.click();
  }
}
// function openSideBar() {
//   const sideBarButton = document.querySelector<HTMLLabelElement>(
//     sideBarButtonQuerySelector
//   );
//   if (sideBarButton !== null) {
//     sideBarButton.classList.add("drawer-open");
//   }
// }

// function closeSideBar() {
//   ("trying to close sidebar");
//   const sideBarButton = document.querySelector<HTMLLabelElement>(
//     sideBarOverlayQuerySelector
//   );
//   if (sideBarButton !== null) {
//     sideBarButton.classList.remove("drawer-open");
//   }
// }

function openMenu() {
  const menuButton = document.querySelector<HTMLLabelElement>(
    openMenuButtonQuerySelector
  );
  if (menuButton !== null) {
    menuButton.classList.add("dropdown-open");
  }
}

function closeMenu() {
  const menuButton = document.querySelector<HTMLLabelElement>(
    openMenuButtonQuerySelector
  );
  if (menuButton !== null) {
    menuButton.classList.remove("dropdown-open");
  }
}

const tutorialStore = create<TutorialContextType>((set) => ({
  run: false,
  stepIndex: 0,
  steps: [
    //index 0 - year tab
    {
      disableBeacon: true,
      title: "Willkommen zum Berichtsheft Generator",
      content:
        "Deine Berichte wurden erstellt und in Ausbildungsjahre sortiert.",
      placement: "bottom",
      target: firstYearTabQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,
      disableOverlayClose: true,
      spotlightClicks: true,
    },
    //index 1 - month accordion
    {
      disableBeacon: true,
      title: "Berichte ansehen",
      content: "Berichte werden in Monate unterteilt.",
      placement: "bottom",
      target: firstMonthAccordionQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 2 - report accordion
    {
      disableBeacon: true,
      title: "Bericht bearbeiten",
      content: "Hier ist eines deiner Berichte.",
      placement: "center",
      target: firstReportPaperQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 3 - report rich text editor
    {
      disableBeacon: true,
      title: "Aufgaben eintragen",
      content: (
        <>
          <span>
            {
              " Du kannst deine Aufgaben direkt in deine Vorlage eintippen. Wenn du mit dem Text zufrieden bist, klicke einfach irgendwo außerhalb des Editors, um die Aufgabe zu speichern."
            }
          </span>
          <br />
          <span>
            <strong>{"Probiere es aus! Erstelle zwei Aufgaben."}</strong>
          </span>
        </>
      ),
      placement: "top",
      target: firstEntryRichTextEditorCell,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      disableScrolling: false,
      tooltipComponent: (props) => <Tooltip {...props} />,
      disableOverlayClose: true,
      spotlightClicks: true,
    },
    //index 4 - entry area
    {
      disableBeacon: true,
      title: "Aufgaben eintragen und sortieren",
      content:
        "Im Anschluß erscheinen die Aufgaben hier und werden einem Aufgabenordner zugeordnet. Um die Reihenfolge der Aufgaben zu ändern, kannst du eine Aufgabe anklicken und in eine neue Position ziehen.",
      placement: "bottom",
      target: firstReportEntryAreaQuerySelector,
      spotlightPadding: 7,
      styles: {
        options: {
          zIndex: 10000,
        },
      },

      tooltipComponent: (props) => <Tooltip {...props} />,
      disableScrolling: true,
      disableOverlayClose: true,
      spotlightClicks: true,
    },
    //index 5 - folder select
    {
      disableBeacon: true,
      title: "Aufgabenordner",
      content: (
        <div className="flex flex-col gap-2 justify-center">
          Hier sind deine Aufgabenordner. Mit dem Dropdown kannst du sie:
          <ol className="list-decimal list-inside">
            <li>erstellen</li>
            <li>bearbeiten</li>
            <li>durchsuchen</li>
            <li>auswählen</li>
          </ol>
        </div>
      ),
      placement: "bottom",
      target: folderSelectQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 6
    {
      disableBeacon: true,
      title: "Aufgabenliste",
      content:
        "Hier sind alle Aufgaben, die dem ausgewählten Aufgabenordner zugeordnet sind.",
      placement: "bottom",
      target: entryListQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 7
    {
      disableBeacon: true,
      title: "Aufgaben filtern",
      content:
        "Um eine Aufgabe schneller, in dem ausgewählten Aufgabenordner zu finden, kannst du hier einen Suchbegriff eintippen.",
      placement: "bottom",
      target: entrySearchQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 8
    {
      disableBeacon: true,
      title: "Aufgaben erstellen",
      content: "Hier kannst du eine neue Aufgabe erstellen.",
      placement: "bottom",
      target: createEntryButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 9
    {
      disableBeacon: true,
      title: "Mehrauswahl",
      content:
        "Hier kannst du eine oder mehrere Aufgaben auswählen und einige Funktionen, mit dieser Auswahl, ausführen.",
      placement: "bottom",
      target: multiSelectButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 10
    {
      disableBeacon: true,
      title: "Aufgabendetails bearbeiten",
      content: "Hier kannst du verschiedene Details einer Aufgabe bearbeiten.",
      placement: "bottom",
      target: entryAccordionQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 11
    {
      disableBeacon: true,
      title: "Aufgabe ins Berichtsheft eintragen",
      content:
        "Hier kannst du die Tage auswählen an denen die Aufgabe erledigt wurde.",
      placement: "bottom",
      target: entryAccordionCompleteEntryButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 12
    {
      disableBeacon: true,
      title: "Aufgabe löschen",
      content:
        "Hier kannst du die Aufgabe löschen. Somit wird sie auch aus allen Berichten entfernt.",
      placement: "bottom",
      target: entryAccordionDeleteEntryButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 13
    {
      disableBeacon: true,
      title: "Vorlagenbereiche",
      content:
        "Aufgaben müssen einem Vorlagenbereich zugeordnet werden, damit der Berichtsheft Generator weiß, in welcher Tabellenzelle der Vorlage die Aufgabe dargestellt werden soll.",
      placement: "bottom",
      target: entryAccordionReportSectionSelectQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 14
    {
      disableBeacon: true,
      title: "Aufgabenbeschreibung bearbeiten",
      content:
        "Hier kannst du die Beschreibung einer Aufgabe bearbeiten. Wenn du die Beschreibung hier änderst, wird sie auch in allen Berichten aktualisiert.",
      placement: "bottom",
      target: entryAccordionRichTextEditorQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 15
    {
      disableBeacon: true,
      title: "Aufgabenname bearbeiten",
      content:
        "Hier kannst du den Namen einer Aufgabe bearbeiten. Der Name dient nur zur besseren Übersicht in der Aufgabenliste.",
      placement: "bottom",
      target: entryAccordionEntryNameQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 16
    {
      disableBeacon: true,
      title: "Aufgabendauer bzw. Stunden bearbeiten",
      content:
        "Hier kannst du die Dauer der Aufgabe, in Stunden, angeben. Dieser Wert wird für die Berechnung der Stunden bzw. Gesamtstunden verwendet.",
      placement: "bottom",
      target: entryAccordionDurationInputQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 17
    {
      disableBeacon: true,
      title: "Aufgaben herunterladen",
      content: "Hier kannst du Aufgaben herunterladen.",
      placement: "bottom",
      target: downloadEntriesButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 18
    {
      disableBeacon: true,
      title: "Aufgaben verteilen",
      content: "Hier kannst du Aufgaben verteilen lassen.",
      placement: "bottom",
      target: randomizeEntriesButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 19
    {
      disableBeacon: true,
      title: "Kalender importieren",
      content:
        "Hier kannst du Einträge, wie z.B. Krank- oder Urlaubstage, aus deinem Firmen- bzw. Privatkalender importieren.",
      placement: "top",
      target: calendarEntriesButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 20
    {
      disableBeacon: true,
      title: "Berichte exportieren",
      content: "Hier kannst du deine Berichte exportieren.",
      placement: "top",
      target: exportReportsButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
    //index 21
    {
      disableBeacon: true,
      title: "Tutorial starten",
      content:
        "Hier kannst du das Tutorial nochmal starten, falls du vergisst, wie man den Berichtsheft Generator benutzt.",
      placement: "top",
      target: startTutorialButtonQuerySelector,
      spotlightPadding: 0,
      styles: {
        options: {
          zIndex: 10000,
        },
      },
      tooltipComponent: (props) => <Tooltip {...props} isLast={true} />,

      disableOverlayClose: true,
      spotlightClicks: false,
    },
  ],
  tourActive: false,
  started: false,
  setStepIndex: (stepIndex: number) => set({ stepIndex }),
  setSteps: (steps: Step[]) => set({ steps }),
  setTourActive: (tourActive: boolean) => set({ tourActive }),
  setRun: (run: boolean) => set({ run }),
  start: ({ index = 0 }) => {
    set({ started: true, stepIndex: index });
    localStorage.setItem("finishedTutorial", "false");
    return set({ run: true, tourActive: true });
  },
  setStarted: (started: boolean) => set({ started }),
  pause: () => set({ run: false }),
}));
export default function useTutorial() {
  return tutorialStore();
}

export const useTutorialCallbackHandler = (tutorial: TutorialContextType) => {
  const { postProtected } = useHttpClient();

  async function setCompletedTutorial() {
    return await postProtected(`/protected/setCompletedTutorial`, null);
  }

  const setIsSidebarExpanded = useBerichtsheft(
    (state) => state.setIsSidebarExpanded
  );
  const handleCallback = async (data: CallBackProps) => {
    const { action, index, lifecycle, status, type } = data;

    const isLastStep = index == data.size;

    if (status == "finished") {
      await onFinished();
    }

    if (action == "close" || isLastStep) {
      await onFinished();
    } else if (
      type == "step:after" &&
      index == 0 /* or step.target == '#home' */
    ) {
      //setState({ run: false });

      if (firstMonthAccordionCheckboxExists()) {
        handlePrevAndNext(index, action, openFirstMonthAccordion, undefined);
      } else {
        //click report accordion instead because month is missing, probably monatliche berichte
        //skip step
        if (action == "next") {
          openFirstReportAccordion();
        }
        waitForElement(firstReportPaperQuerySelector, 500, () =>
          handlePrevAndNext(index + 1, action)
        );
      }
    } else if (type == "step:after" && index == 1) {
      //setState({ run: false });

      if (action == "next") {
        openFirstReportAccordion();
        waitForElement(firstReportPaperQuerySelector, 500, () =>
          handlePrevAndNext(index, action)
        );
      } else {
        handlePrevAndNext(index, action);
      }
    } else if (type == "step:after" && index == 2) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 3) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 4) {
      setIsSidebarExpanded(true);
      setTimeout(() => {
        handlePrevAndNext(index, action);
      }, 500);
    } else if (type == "step:after" && index == 5) {
      waitForElement(
        folderSelectQuerySelector,
        500,
        () => {
          const entryListExists = elementExists(entryListQuerySelector);
          if (!entryListExists) {
            setIsSidebarExpanded(false);
            setTimeout(() => {
              return handlePrevAndNext(index + 11, action);
            }, 500);
          }

          return handlePrevAndNext(index, action);
        },
        true
      );
    } else if (type == "step:after" && index == 6) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 7) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 8) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 9) {
      const exists = elementExists(entryAccordionCheckboxQuerySelector);

      const indexToNavigateTo = exists ? index : 16; //one will be added in handleprevandnext so index = 17
      //if we dont skip ahead tutorial will fail because user didnt create any entries! in this case skip important functions but allow user to finish tutorial.
      if (exists) {
        openFirstEntryAccordion();

        setTimeout(() => {
          handlePrevAndNext(indexToNavigateTo, action);
        }, 500);
      } else {
        handlePrevAndNext(indexToNavigateTo, action);
      }
    } else if (type == "step:after" && index == 10) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 11) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 12) {
      if (reportSectionSelectExists()) {
        handlePrevAndNext(index, action);
      } else {
        handlePrevAndNext(index + 1, action);
      }
    } else if (type == "step:after" && index == 13) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 14) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 15) {
      if (durationInputExists()) {
        handlePrevAndNext(index, action);
      } else {
        handlePrevAndNext(index + 1, action);
        //skip one step so it doesnt fail, probably the template doesnt have maxHours
        // closeSideBar();
        // setTimeout(() => {
        //     handlePrevAndNext(index + 1, action);
        // }, 500);
      }
    } else if (type == "step:after" && index == 16) {
      setIsSidebarExpanded(false);

      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 17) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 18) {
      openMenu();
      setTimeout(() => {
        handlePrevAndNext(index, action);
      }, 500);
    } else if (type == "step:after" && index == 19) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 20) {
      handlePrevAndNext(index, action);
    } else if (type == "step:after" && index == 21) {
      closeMenu();
      setTimeout(() => {
        handlePrevAndNext(index, action);
      }, 500);
    } else if (type == "step:after" && index == 22) {
      handlePrevAndNext(index, action);
    } else if (action == "reset" || lifecycle == "complete") {
      //setState({ run: false, stepIndex: 0, tourActive: false });
      tutorial.setRun(false);
      tutorial.setStepIndex(0);
      tutorial.setTourActive(false);
      tutorial.setStarted(false);
    }

    function waitForElement(
      selector: string,
      ms: number = 500,
      callback: () => void,
      scrollIntoView = true
    ) {
      const element = document.querySelector(selector);
      if (scrollIntoView && element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      if (element) {
        callback();
      } else {
        setTimeout(() => {
          waitForElement(selector, ms, callback);
        }, ms);
      }
    }

    async function onFinished() {
      setIsSidebarExpanded(false);
      localStorage.setItem("finishedTutorial", "true");
      await setCompletedTutorial();
      tutorial.setRun(false);
      tutorial.setStepIndex(0);
      tutorial.setTourActive(false);
      tutorial.setStarted(false);
    }

    function handlePrevAndNext(
      index: number,
      action: string,
      performBeforeNext?: () => void,
      performBeforePrev?: () => void
    ) {
      var nextStep;
      if (action == "next") {
        //setState({ run: false });
        performBeforeNext && performBeforeNext();
        nextStep = index + 1;
      } else {
        //setState({ run: true, stepIndex: 0 });

        switch (index) {
          case 17:
            nextStep = elementExists(entryAccordionCheckboxQuerySelector)
              ? 16
              : elementExists(entryAccordionEntryNameQuerySelector)
              ? 9
              : 5;
            break;
          case 13:
            nextStep = reportSectionSelectExists() ? 12 : 11;
            break;
          case 14:
            nextStep = reportSectionSelectExists() ? 13 : 12;
            break;
          case 2:
            nextStep = firstMonthAccordionCheckboxExists() ? 1 : 0;
            break;
          default:
            nextStep = index - 1;
        }

        performBeforePrev && performBeforePrev();
      }

      tutorial.setStepIndex(nextStep);
    }
  };

  return handleCallback;
};
